module.exports = __webpack_public_path__ + "static/media/3_bill_sad.699553e0.svg";